import { Card, CardBody, Col } from "reactstrap";
import { ZERO_CONFIGURATION_COLUMN, ZERO_CONFIGURATION_DATA } from "../../../../Data/DataTable/ZeroConfiguration";
import DataTable from "react-data-table-component";
import ZeroConfigurationHeader from "./ZeroConfigurationHeader";

export const ZeroConfigurationTable = () => {
  return (
    <Col sm="12">
      <Card>
        <ZeroConfigurationHeader />
        <CardBody>
          <div className="table-responsive">
            <DataTable data={ZERO_CONFIGURATION_DATA} columns={ZERO_CONFIGURATION_COLUMN} pagination highlightOnHover striped />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
